import React, { useContext, useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Checkbox,
  FormControlLabel,
  Box,
} from "@mui/material";
import closeIcon from "../../../../../../../images/ai_image/closeIcon.svg";
import { StoreContext } from "../../../../../../store/StoreProvider";
import arrowRightIcon from "../../../../../../../images/dialog/arrowRightcon.svg";
import Act from "../../../../../../store/actions";

const EventCategoryDialog = () => {
  const [events, setEvents] = useState([]);
  const [curMainEvn, setCurMainEvn] = useState({});
  const [curSubEvn, setCurSubEvn] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [isFocused, setIsFocused] = useState("");
  const [state, dispatch] = useContext(StoreContext);
  const { sna } = state;
  const { evnCtgDialog } = sna;

  const handleSelectAll = () => {
    setSelectAll(!selectAll);
  };

  const handleClose = () => {
    setCurMainEvn({});
    setCurSubEvn([]);
    setIsFocused("");
    dispatch({ type: Act.SNA_SET_EVN_CTG_DIALOG, payload: false });
  };

  const handleSure = () => {
    dispatch({ type: Act.SNA_EVENT_TYPES_CHANGE, payload: events });
    handleClose();
  };

  const handleClickParent = (item) => {
    const subEvns = events.filter((el) => el.pid === item.evtTypeId);
    setCurMainEvn(item);
    setCurSubEvn(subEvns);
  };

  const handleChangeParent = (e, item) => {
    const newEvents = events.map((el) => {
      if (el.evtTypeId === item.evtTypeId || el.pid === item.evtTypeId) {
        return { ...el, checked: e.target.checked };
      }
      return el;
    });
    setEvents(newEvents);
  };

  const handleChangeChild = (e, item) => {
    let newEvents = events.map((el) => {
      if (el.evtTypeId === item.evtTypeId) {
        return { ...el, checked: e.target.checked };
      }
      return el;
    });

    if (item.name === "未分類") {
      newEvents = newEvents.map((el) => {
        if (el.evtTypeId === item.pid) {
          return { ...el, checked: e.target.checked };
        }
        return el;
      });
    }

    const parentEvent = newEvents.find((el) => el.evtTypeId === item.pid);
    if (parentEvent) {
      const allSiblingsUnchecked = newEvents
        .filter((el) => el.pid === item.pid)
        .every((el) => !el.checked);

      if (allSiblingsUnchecked) {
        const updatedEvents = newEvents.map((el) => {
          if (el.evtTypeId === item.pid) {
            return { ...el, checked: false };
          }
          return el;
        });
        setEvents(updatedEvents);
      } else {
        setEvents(newEvents);
      }
    } else {
      setEvents(newEvents);
    }
  };

  useEffect(() => {
    setEvents(sna.filter.eventTypes.change);
  }, [sna.filter.eventTypes.change]);

  useEffect(() => {
    if (events.length > 0) {
      const foundUnCtg = events.some((el) => el.name === "未分類");
      if (!foundUnCtg) {
        const newEvents = [...events];
        newEvents.forEach((event) => {
          if (event.pid === "EVTTYPE0") {
            const UnctgId = `EVTTYPE${uuidv4()}`;
            newEvents.push({
              checked: false,
              evtTypeId: UnctgId,
              id: UnctgId,
              label: "未分類",
              name: "未分類",
              pid: event.evtTypeId,
              step: 1,
              type: "EventType",
            });
          }
        });
        setEvents(newEvents);
      }
    }
  }, [events]);

  useEffect(() => {
    const subEvns = events.filter((el) => el.pid === curMainEvn.evtTypeId);
    setCurSubEvn(subEvns);
  }, [events, curMainEvn]);

  useEffect(() => {
    const newEvents = events.map((el) => ({ ...el, checked: selectAll }));
    setEvents(newEvents);
  }, [selectAll]);

  return (
    <Dialog
      open={evnCtgDialog}
      onClose={handleClose}
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100%",
            maxWidth: "800px",
            height: "100%",
            maxHeight: "600px",
            padding: "16px",
            borderRadius: "8px",
            backgroundColor: "#F7F8FA",
          },
        },
      }}
    >
      <Box sx={{ display: "flex", justifyContent: "end", width: "100%" }}>
        <button
          type="button"
          onClick={handleClose}
          style={{
            backgroundColor: "transparent",
            border: "none",
            cursor: "pointer",
          }}
        >
          <img src={closeIcon} alt="close" />
        </button>
      </Box>
      <Box
        sx={{
          padding: "0px 24px 8px 24px",
          width: "100%",
          height: "calc(100% - 36px)",
        }}
      >
        <DialogTitle
          sx={{
            textAlign: "center",
            fontSize: "20px",
            fontWeight: "700",
            padding: "0",
          }}
        >
          事件分類
        </DialogTitle>
        <DialogContent
          sx={{
            padding: "24px 0 !important",
            display: "flex",
            justifyContent: "space-between",
            height: "calc(100% - 71px)",
          }}
        >
          <Box
            sx={{
              width: "49%",
              backgroundColor: "#FFFFFF",
              height: "100%",
            }}
          >
            <Box
              sx={{
                borderBottom: "0.5px solid #E7E7E7",
                padding: "12px 16px",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <p
                style={{
                  margin: "0",
                  fontWeight: "700",
                  fontSize: "14px",
                  lineHeight: "20.27px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                主事件
              </p>
              <button
                type="button"
                style={{
                  fontWeight: "400",
                  fontSize: "14px",
                  lineHeight: "20.27px",
                  color: "#121212",
                  border: "none",
                  borderBottom: "1px solid #121212",
                  height: "20.27px",
                  backgroundColor: "transparent",
                  cursor: "pointer",
                  padding: "0",
                }}
                onClick={handleSelectAll}
              >
                {!selectAll ? "全選" : "取消全選"}
              </button>
            </Box>
            <Box
              sx={{
                overflowY: "auto",
                display: "flex",
                flexDirection: "column",
                height: "calc(100% - 61.5px)",
              }}
            >
              {events
                .filter((el) => el.pid === "EVTTYPE0")
                .map((el) => (
                  <Button
                    key={el.evtTypeId}
                    sx={{
                      padding: "12px 16px",
                      borderBottom: "0.5px solid #E7E7E7",
                      width: "100%",
                      display: "flex",
                      justifyContent: "space-between",
                      color: "black",
                      fontSize: "1rem",
                      backgroundColor: isFocused === el.evtTypeId && "#F0F9FF",
                    }}
                    onClick={() => handleClickParent(el)}
                    onFocus={() => setIsFocused(el.evtTypeId)}
                  >
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={
                            (events.filter((item) => el.evtTypeId === item.pid)
                              .length > 0 &&
                              events
                                .filter((item) => el.evtTypeId === item.pid)
                                .every((e) => e.checked)) ||
                            el.checked
                          }
                          indeterminate={
                            events.filter((item) => el.evtTypeId === item.pid)
                              .length > 0 &&
                            events
                              .filter((item) => el.evtTypeId === item.pid)
                              .some((e) => e.checked) &&
                            !events
                              .filter((item) => el.evtTypeId === item.pid)
                              .every((e) => e.checked)
                          }
                          onChange={(e) => handleChangeParent(e, el)}
                          sx={{ paddingTop: 0, paddingBottom: 0 }}
                        />
                      }
                      label={
                        <Box
                          component="span"
                          sx={{
                            whiteSpace: "normal",
                            wordBreak: "break-word",
                            display: "block",
                            textAlign: "left",
                            fontSize: "14px",
                          }}
                        >
                          {el.name}
                        </Box>
                      }
                    />
                    {isFocused === el.evtTypeId && (
                      <img src={arrowRightIcon} alt="arrowRight" />
                    )}
                  </Button>
                ))}
            </Box>
          </Box>
          <Box
            sx={{
              width: "49%",
              backgroundColor: "#FFFFFF",
              height: "100%",
            }}
          >
            <Box
              sx={{
                borderBottom: "0.5px solid #E7E7E7",
                padding: "12px 16px",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <p
                style={{
                  margin: "0",
                  fontWeight: "700",
                  fontSize: "14px",
                  lineHeight: "20.27px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                子事件
              </p>
            </Box>
            <Box
              sx={{
                overflowY: "auto",
                display: "flex",
                flexDirection: "column",
                height: "calc(100% - 61.5px)",
              }}
            >
              {curSubEvn.map((el) => (
                <FormControlLabel
                  key={el.evtTypeId}
                  label={
                    <Box
                      component="span"
                      sx={{
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                        display: "block",
                        textAlign: "left",
                        fontSize: "14px",
                      }}
                    >
                      {el.name}
                    </Box>
                  }
                  control={
                    <Checkbox
                      checked={el.checked}
                      onChange={(e) => handleChangeChild(e, el)}
                      sx={{ paddingTop: 0, paddingBottom: 0 }}
                    />
                  }
                  sx={{
                    padding: "12px 16px",
                    borderBottom: "0.5px solid #E7E7E7",
                    margin: "0",
                  }}
                />
              ))}
            </Box>
          </Box>
        </DialogContent>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
          }}
        >
          <Button
            onClick={handleClose}
            sx={{
              width: "49%",
              height: "39px",
              border: "1px solid #E7E7E7",
              padding: "8px 24px",
              color: "black",
            }}
          >
            取消
          </Button>
          <Button
            onClick={handleSure}
            sx={{
              width: "49%",
              height: "39px",
              padding: "8px 24px",
              background: "linear-gradient(90deg, #38BBF8 0%, #0EA2E9 100%)",
              color: "white",
              boxShadow: "0px 0px 16px 0px rgba(59, 191, 240, 0.2)",
            }}
          >
            確認
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
};

export default EventCategoryDialog;
